<p class="title" mat-dialog-title>{{ "cookieBannerComponent.title" | translate}}</p>
<mat-dialog-content>
    <p>{{ "cookieBannerComponent.contentOne" | translate}}</p>
    <br />
    <p>{{ "cookieBannerComponent.contentTwo" | translate}}&nbsp;<span>{{ "cookieBannerComponent.contentThree" |
            translate}}</span></p>
    <button mat-button (click)="onAcceptClicked()">{{ "cookieBannerComponent.acceptCookies" | translate}}</button>
    <button mat-button (click)="onDeclineClicked()">{{ "cookieBannerComponent.declineCookies" | translate}}</button>
</mat-dialog-content>